import * as React from "react";
import { VStack } from "@chakra-ui/react";
import { Form, TextInput } from "components";
import { useCurrentCase } from "duck";
import { getValidation, useUpdatePostAnestheticVitalComment } from "./duck";

const Comments: React.FC = () => {
  const postAnesthesiaComments = useCurrentCase(
    ({ data }) => data.client.patient.postAnestheticVitalComment
  );

  const validation = React.useMemo(
    () => getValidation(postAnesthesiaComments),
    [postAnesthesiaComments]
  );

  const update = useUpdatePostAnestheticVitalComment(
    postAnesthesiaComments?._id
  );

  return !postAnesthesiaComments ? null : (
    <Form {...validation}>
      <Form.Watcher
        defaultValues={validation.defaultValues}
        onChange={update}
      />
      <VStack spacing={6} alignItems="start">
        <TextInput
          type="text-area"
          name="comment"
          label="Additional comments and notes"
          placeholder="Enter Additional comments and notes"
        />
        <TextInput
          type="text-area"
          name="surgeryReport"
          label="Surgery Report"
          placeholder="Enter surgery report"
        />
      </VStack>
    </Form>
  );
};

export default Comments;
